import React from 'react';
import { useDispatch } from 'react-redux';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { undoMaterialWastage } from '@services/materialService';

import { changeDateFormat } from '@utils/Util';

const WastageTab = ({ wastageList, consumptionUnit, getAllIssueAndReceivedInventory }) => {
	const dispatch = useDispatch();

	const handleUndo = async (id) => {
		dispatch(openLoader());
		await undoMaterialWastage(id);
		await getAllIssueAndReceivedInventory();
		dispatch(closeLoader());
	};

	const renderTableBody = () => {
		return wastageList?.map((item) => {
			return (
				<tr key={`wastage_${item.id}`}>
					<td>{item.status === 'LOW_QUANTITY_WASTAGE' ? 'Low qty' : 'Expired'}</td>
					<td>{item.quantity}</td>
					<td>{item.user?.name}</td>
					<td>{changeDateFormat(item?.date, 'YYYY-MM-DD', 'DD MMM, YY')}</td>
					<td>
						<div className="actions">
							<div className="dropdown">
								<button
									className="btn btn-default"
									type="button"
									id="menu1"
									data-toggle="dropdown"
									aria-expanded="false"
								>
									<img src={`${process.env.PUBLIC_URL}/icons/more_icon.svg`} alt="option" />
								</button>
								<ul
									className="dropdown-menu shadow-lg"
									role="menu"
									aria-labelledby="menu1"
									x-placement="bottom-end"
								>
									<li onClick={() => handleUndo(item.id)}>
										<span>Undo</span>
									</li>
								</ul>
							</div>
						</div>
					</td>
				</tr>
			);
		});
	};

	const total = wastageList.reduce((total, item) => total + item.quantity, 0);

	return (
		<table className="table with-border no-hover height-sm update-projection-table">
			<thead>
				<tr>
					<th>Reason</th>
					<th>Qty ({consumptionUnit})</th>
					<th>Marked by</th>
					<th>Date</th>
					<th>Action</th>
				</tr>
			</thead>
			<tbody>
				{renderTableBody()}
				<tr>
					<td>
						<span className="gray_dark_01">Total</span>
					</td>
					<td>
						<span className="gray_dark_01">
							{total} {consumptionUnit}
						</span>
					</td>
					<td />
					<td />
					<td />
				</tr>
			</tbody>
		</table>
	);
};

export default WastageTab;
